(() => {
  const body = document.body;
  const headerSection = document.querySelector('[data-header-section]');
  const headerPlaceholder = document.createElement('div');
  headerPlaceholder.className = 'site-header-placeholder';
  headerPlaceholder.setAttribute('aria-hidden', 'true');
  headerSection?.after(headerPlaceholder);
  let lastScrollY = window.scrollY;
  const syncStickyHeader = () => {
    if (!headerSection) return;
    const currentY = Math.max(window.scrollY, 0);
    const headerHeight = headerSection.offsetHeight;
    // Keep the measured initial header region in normal flow before enabling
    // direction-aware fixing. The desktop reference remains unchanged through
    // scrollY=200; mobile uses its shorter header region.
    const fixationThreshold = window.matchMedia('(max-width: 749px)').matches
      ? headerHeight + 32
      : Math.max(headerHeight + 64, 240);
    const shouldFix = currentY > fixationThreshold;
    const movingDown = currentY > lastScrollY + 2;
    const movingUp = currentY < lastScrollY - 2;
    headerSection.classList.toggle('is-scrolled', currentY > 0);
    headerSection.classList.toggle('is-fixed', shouldFix);
    if (shouldFix && movingDown) headerSection.classList.add('is-hidden');
    if (!shouldFix || movingUp) headerSection.classList.remove('is-hidden');
    headerPlaceholder.style.height = shouldFix && !body.classList.contains('template-index') ? `${headerHeight}px` : '0px';
    lastScrollY = currentY;
  };
  syncStickyHeader();
  window.addEventListener('scroll', syncStickyHeader, { passive: true });
  const backdrop = document.querySelector('[data-drawer-backdrop]');
  const toggleBackdrop = (open, variant = 'drawer') => {
    backdrop?.classList.toggle('is-open', open);
    if (backdrop) backdrop.dataset.variant = open ? variant : '';
    body.classList.toggle('drawer-open', open);
  };

  const megaMenu = document.querySelector('[data-mega-menu]');
  const megaBackdrop = document.querySelector('[data-mega-backdrop]');
  const megaItems = [...document.querySelectorAll('[data-mega-item]')];
  let megaOpenTimer;
  let megaCloseTimer;
  let activeMegaItem = null;
  const setMegaMenu = (item, open) => {
    window.clearTimeout(megaOpenTimer);
    window.clearTimeout(megaCloseTimer);
    const button = item?.querySelector('[data-mega-toggle]');
    if (!open || !item || !button) {
      activeMegaItem = null;
      megaItems.forEach((entry) => {
        entry.classList.remove('is-open');
        entry.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      megaMenu?.classList.remove('is-open');
      megaBackdrop?.classList.remove('is-open');
      headerSection?.classList.remove('has-mega-open');
      window.setTimeout(() => megaMenu?.querySelectorAll('[data-mega-panel]').forEach((panel) => { panel.hidden = true; }), 260);
      return;
    }
    activeMegaItem = item;
    const top = headerSection?.getBoundingClientRect().bottom || 140;
    headerSection?.style.setProperty('--mega-menu-top', `${Math.max(top, 0)}px`);
    megaItems.forEach((entry) => {
      const selected = entry === item;
      entry.classList.toggle('is-open', selected);
      entry.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', String(selected));
    });
    megaMenu?.querySelectorAll('[data-mega-panel]').forEach((panel) => { panel.hidden = panel.dataset.megaPanel !== button.dataset.megaToggle; });
    megaMenu?.classList.add('is-open');
    megaBackdrop?.classList.add('is-open');
    headerSection?.classList.add('has-mega-open');
  };
  const scheduleMegaOpen = (item) => {
    window.clearTimeout(megaCloseTimer);
    megaOpenTimer = window.setTimeout(() => setMegaMenu(item, true), 80);
  };
  const scheduleMegaClose = () => {
    window.clearTimeout(megaOpenTimer);
    megaCloseTimer = window.setTimeout(() => setMegaMenu(null, false), 160);
  };
  megaItems.forEach((item) => {
    const button = item.querySelector('[data-mega-toggle]');
    if (!button) return;
    item.addEventListener('pointerenter', () => scheduleMegaOpen(item));
    item.addEventListener('pointerleave', scheduleMegaClose);
    item.addEventListener('focusin', () => scheduleMegaOpen(item));
    button.addEventListener('click', (event) => {
      event.preventDefault();
      setMegaMenu(item, activeMegaItem !== item);
    });
  });
  megaMenu?.addEventListener('pointerenter', () => window.clearTimeout(megaCloseTimer));
  megaMenu?.addEventListener('pointerleave', scheduleMegaClose);
  megaBackdrop?.addEventListener('click', () => setMegaMenu(null, false));
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-mega-item]') && !event.target.closest('[data-mega-menu]')) {
      setMegaMenu(null, false);
    }
  });

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileRoot = mobileMenu?.querySelector('[data-mobile-menu-root]');
  const resetMobileSubmenu = () => {
    mobileRoot?.classList.add('is-active');
    mobileRoot?.removeAttribute('hidden');
    mobileMenu?.querySelectorAll('[data-mobile-submenu]').forEach((panel) => {
      panel.classList.remove('is-active');
      panel.hidden = true;
    });
  };
  let mobileMenuHideTimer;
  const setMobileMenu = (open) => {
    window.clearTimeout(mobileMenuHideTimer);
    if (open && mobileMenu) {
      mobileMenu.style.removeProperty('display');
      mobileMenu.inert = false;
      void mobileMenu.offsetWidth;
    }
    mobileMenu?.classList.toggle('is-open', open);
    mobileMenu?.setAttribute('aria-hidden', String(!open));
    document.querySelector('[data-mobile-menu-toggle]')?.setAttribute('aria-expanded', String(open));
    toggleBackdrop(open, 'navigation');
    if (!open && mobileMenu) {
      mobileMenu.inert = true;
      mobileMenuHideTimer = window.setTimeout(() => {
        mobileMenu.style.display = 'none';
        resetMobileSubmenu();
      }, 220);
    }
  };
  document.querySelector('[data-mobile-menu-toggle]')?.addEventListener('click', () => setMobileMenu(true));
  document.querySelector('[data-mobile-menu-close]')?.addEventListener('click', () => setMobileMenu(false));
  mobileMenu?.querySelectorAll('[data-mobile-submenu-toggle]').forEach((button) => button.addEventListener('click', () => {
    const panel = mobileMenu.querySelector(`[data-mobile-submenu="${button.dataset.mobileSubmenuToggle}"]`);
    if (!panel) return;
    mobileRoot?.classList.remove('is-active');
    panel.hidden = false;
    window.requestAnimationFrame(() => panel.classList.add('is-active'));
    panel.querySelector('[data-mobile-submenu-back]')?.focus();
  }));
  mobileMenu?.querySelectorAll('[data-mobile-submenu-back]').forEach((button) => button.addEventListener('click', () => {
    const panel = button.closest('[data-mobile-submenu]');
    panel?.classList.remove('is-active');
    mobileRoot?.classList.add('is-active');
    window.setTimeout(() => { if (panel) panel.hidden = true; }, 220);
  }));
  backdrop?.addEventListener('click', () => {
    setMobileMenu(false);
    if (filterPanel?.classList.contains('is-open')) setFilterPanel(false);
  });

  const setVideoSource = (video) => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const source = mobile ? video.dataset.mobileSrc : video.dataset.desktopSrc;
    if (!source || video.dataset.activeSrc === source) return;
    video.dataset.activeSrc = source;
    video.src = source;
    video.load();
    video.play().catch(() => {});
  };
  document.querySelectorAll('[data-video]').forEach((video) => setVideoSource(video));
  window.addEventListener('resize', () => document.querySelectorAll('[data-video]').forEach((video) => setVideoSource(video)));
  document.querySelectorAll('[data-hero-slide]').forEach((slide) => {
    const video = slide.querySelector('video:not(.hero-slide__video--mobile)');
    const mobileVideo = slide.querySelector('.hero-slide__video--mobile');
    const getActiveVideo = () => window.matchMedia('(max-width: 749px)').matches ? mobileVideo : video;
    slide.querySelector('[data-video-play]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const active = getActiveVideo();
      if (!active) return;
      const button = event.currentTarget;
      if (active.paused) { active.play().catch(() => {}); button.innerHTML = '<svg class="icon icon-pause" viewBox="0 0 24 24"><path d="M8 6v12M16 6v12"></path></svg>'; button.setAttribute('aria-label', 'Video is playing'); }
      else { active.pause(); button.innerHTML = '<svg class="icon icon-play" viewBox="0 0 24 24"><path d="m9 6 9 6-9 6V6Z" fill="currentColor" stroke="none"></path></svg>'; button.setAttribute('aria-label', 'Video is not playing'); }
    });
    slide.querySelector('[data-video-mute]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const active = getActiveVideo();
      if (!active) return;
      active.muted = !active.muted;
      event.currentTarget.innerHTML = active.muted ? '<svg class="icon icon-volume-off" viewBox="0 0 24 24"><path d="M5 10h3l4-4v12l-4-4H5z"></path><path d="m16 9 4 6m0-6-4 6"></path></svg>' : '<svg class="icon icon-volume" viewBox="0 0 24 24"><path d="M5 10h3l4-4v12l-4-4H5z"></path><path d="M16 9.5a4 4 0 0 1 0 5M18.5 7a7.5 7.5 0 0 1 0 10"></path></svg>';
      event.currentTarget.setAttribute('aria-label', active.muted ? 'Video is mute' : 'Video is not mute');
    });
  });

  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const setFilterPanel = (open) => {
    filterPanel?.classList.toggle('is-open', open);
    filterPanel?.setAttribute('aria-hidden', String(!open));
    filterToggle?.setAttribute('aria-expanded', String(open));
    toggleBackdrop(open, 'filter');
    if (open) window.setTimeout(() => filterPanel?.querySelector('[data-filter-close]')?.focus(), 300);
  };
  document.querySelector('[data-filter-toggle]')?.addEventListener('click', () => setFilterPanel(true));
  document.querySelector('[data-filter-close]')?.addEventListener('click', () => setFilterPanel(false));
  document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.href = url.toString();
  });

  const variantData = document.querySelector('[data-product-variants]');
  const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
  const productForm = document.querySelector('.product-form');
  const variantId = productForm?.querySelector('[data-variant-id]');
  const productPrice = productForm?.querySelector('[data-product-price]');
  const productGallery = document.querySelector('[data-gallery]');
  const optionInputs = [...document.querySelectorAll('[data-option-position]')];
  const syncVariantFromUrl = () => {
    if (!variants.length || !optionInputs.length) return;
    const requestedId = new URL(window.location.href).searchParams.get('variant');
    if (!requestedId) return;
    const requested = variants.find((item) => String(item.id) === String(requestedId));
    if (!requested) return;
    optionInputs.forEach((input) => {
      const position = Number(input.dataset.optionPosition);
      input.checked = requested.options[position - 1] === input.value;
    });
  };
  const updateVariant = (updateUrl = true) => {
    if (!variants.length || !variantId) return;
    const chosen = {};
    optionInputs.forEach((input) => { if (input.checked) chosen[input.dataset.optionPosition] = input.value; });
    const variant = variants.find((item) => item.options.every((value, index) => !chosen[index + 1] || chosen[index + 1] === value));
    if (!variant) return;
    variantId.value = variant.id;
    Object.entries(chosen).forEach(([position, value]) => {
      const selected = document.querySelector(`[data-selected-option="${position}"]`);
      if (selected) selected.textContent = value;
    });
    if (productPrice) productPrice.innerHTML = `${variant.compare_at_price ? `<s>${variant.compare_at_price}</s>` : ''}<span>${variant.price}</span>`;
    const addButton = productForm.querySelector('[data-add-to-cart]');
    if (addButton) { addButton.disabled = !variant.available; addButton.textContent = variant.available ? 'Add to Bag' : 'Sold out'; }
    if (variant.featured_media_id && productGallery) {
      const media = productGallery.querySelector(`[data-media-id="${variant.featured_media_id}"]`);
      if (media && media !== productGallery.firstElementChild) productGallery.prepend(media);
      if (media && window.matchMedia('(max-width: 749px)').matches) productGallery.scrollTo({ left: 0, behavior: 'smooth' });
    }
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  };
  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  syncVariantFromUrl();
  updateVariant(false);
  document.querySelectorAll('[data-demo-add]').forEach((button) => button.addEventListener('click', () => { button.textContent = 'Added to Bag'; button.classList.add('is-added'); }));
  document.querySelector('[data-sticky-add]')?.addEventListener('click', () => document.querySelector('[data-add-to-cart], [data-demo-add]')?.click());
  const productFormObserver = document.querySelector('.product-form');
  const sticky = document.querySelector('.product-sticky-add');
  if (productFormObserver && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.1 }).observe(productFormObserver);
  }

  const lightbox = document.querySelector('[data-gallery-lightbox]');
  const lightboxSlides = [...(lightbox?.querySelectorAll('[data-gallery-slide]') || [])];
  const lightboxThumbs = [...(lightbox?.querySelectorAll('[data-gallery-thumb]') || [])];
  let activeLightboxIndex = 0;
  let lightboxReturnFocus = null;
  const setLightboxSlide = (index) => {
    if (!lightboxSlides.length) return;
    activeLightboxIndex = (index + lightboxSlides.length) % lightboxSlides.length;
    lightboxSlides.forEach((slide, slideIndex) => {
      const active = slideIndex === activeLightboxIndex;
      slide.classList.toggle('is-active', active);
      slide.hidden = !active;
    });
    lightboxThumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === activeLightboxIndex;
      thumb.classList.toggle('is-active', active);
      if (active) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    lightboxThumbs[activeLightboxIndex]?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };
  const setLightbox = (open, index = activeLightboxIndex) => {
    if (!lightbox) return;
    if (open) {
      lightboxReturnFocus = document.activeElement;
      setLightboxSlide(index);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      body.classList.add('lightbox-open');
      window.requestAnimationFrame(() => lightbox.classList.add('is-open'));
      lightbox.querySelector('[data-gallery-close]')?.focus();
      return;
    }
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    body.classList.remove('lightbox-open');
    window.setTimeout(() => { lightbox.hidden = true; }, 250);
    lightboxReturnFocus?.focus?.();
  };
  document.querySelectorAll('[data-gallery-open]').forEach((button, index) => button.addEventListener('click', () => setLightbox(true, index)));
  lightboxThumbs.forEach((button, index) => button.addEventListener('click', () => setLightboxSlide(index)));
  lightbox?.querySelector('[data-gallery-close]')?.addEventListener('click', () => setLightbox(false));
  lightbox?.querySelector('[data-gallery-previous]')?.addEventListener('click', () => setLightboxSlide(activeLightboxIndex - 1));
  lightbox?.querySelector('[data-gallery-next]')?.addEventListener('click', () => setLightboxSlide(activeLightboxIndex + 1));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (lightbox?.classList.contains('is-open')) setLightbox(false);
      else if (mobileMenu?.classList.contains('is-open')) setMobileMenu(false);
      else if (filterPanel?.classList.contains('is-open')) setFilterPanel(false);
      else setMegaMenu(null, false);
    }
    if (!lightbox?.classList.contains('is-open')) return;
    if (event.key === 'ArrowRight') setLightboxSlide(activeLightboxIndex + 1);
    if (event.key === 'ArrowLeft') setLightboxSlide(activeLightboxIndex - 1);
  });

  document.querySelectorAll('[data-content-accordion]').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;
    const sync = () => summary.setAttribute('aria-expanded', String(details.open));
    sync();
    details.addEventListener('toggle', sync);
  });

  const footerBreakpoint = window.matchMedia('(max-width: 749px)');
  const syncFooterAccordions = () => {
    document.querySelectorAll('[data-site-footer] .footer-column').forEach((column) => {
      column.open = !footerBreakpoint.matches;
    });
  };
  syncFooterAccordions();
  footerBreakpoint.addEventListener?.('change', syncFooterAccordions);

  const cookieConsent = document.querySelector('[data-cookie-consent]');
  const cookieKey = 'pandora-cookie-choice';
  if (cookieConsent && !window.localStorage.getItem(cookieKey)) cookieConsent.hidden = false;
  document.querySelectorAll('[data-cookie-settings-trigger]').forEach((button) => button.addEventListener('click', () => {
    if (!cookieConsent) return;
    cookieConsent.hidden = false;
    cookieConsent.querySelector('[data-cookie-choice]')?.focus();
  }));
  document.querySelectorAll('[data-cookie-choice]').forEach((button) => button.addEventListener('click', () => {
    window.localStorage.setItem(cookieKey, button.dataset.cookieChoice || 'necessary');
    if (cookieConsent) cookieConsent.hidden = true;
  }));
})();
